import css from 'styled-jsx/css';

const styles = css.global`.cta-card {
  padding: 0;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.cta-card a {
  width: 100%;
}

.cta-card h3 {
  display: none;
  /* max-width: 288px; */
  color: #222222;
  font-family: 'SantanderHeadline';
  font-size: 18px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: left;
  margin: 0;
  margin-bottom: 32px;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.cta-card .cta-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  margin-bottom: 16px;
}

.cta-btn-disabled {
  display: none;
}

@media (min-width: 992px) {
  .cta-card {
    padding: 28px 16px;
    border: 1px solid #cccccc;
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: 0 2px 8px -2px rgba(34, 34, 34, 0.4);
  }
  .cta-card h3 {
    display: block;
    max-width: 757px;
    color: #222222;
    font-size: 24px;
    letter-spacing: 0;
    line-height: 36px;
  }

  .cta-btn-disabled {
    display: flex;
  }
}
`;

export default styles;